export const lang = {
  zw: "中文",
  yw: "English",
  back: "返回",
  search: "搜索",
  home: "首页",
  newsinfo: "新闻动态",
  cmpintr: "公司简介",
  newproduct: "新品发布",
  downloadcenter: "下载中心",
  more: "更多",
  product: "产品",
  productcenter: "产品中心",
  productcenter1: "Product Center",
  authentication: "国际认证",
  advantage: "我们的优势",
  authentication1: "International certification",
  advantage1: "Our Strengths",
  advtext1:
    "对欧美、日本等地区的市场和全球零售市场有着非常好的销售和售后服务经验",
  advtext2: "更新换代了155台高效的注塑生产设备，产能优势明显",
  advtext3: "非常专业的团队和实验室设备，确保生产品质把控",
  advtext4: "拥有自己的模具车间，可以根据客户需求开发设计新的产品",
  advtext5: "在美国本地拥有专业的售后服务团队",
  advtext6: "在美国，欧美及日本市场拥有很高的知名度和声誉",
  contactus: "联系我们",
  addtext: "上海市闵行区虹梅南路4828号",
  add: "地址",
  tel: "电话",
  fex: "传真",
  view: "查看详情",
  about: "关于我们",
  aboutext1:
    "上海新龙塑料制造有限公司是一家世界级的制造商，为全球市场提供广泛的电缆扎带、终端等定制产品。公司目前管理着超过2亿人民币(约合3200万美元)的资产。占地35，000平方米设施(377， 000平方英尺)每天24小时、每周7天运营。公司400名员工的目标是始终如一地为客户提供优质的产品和服务。我们与客户合作开发新产品，满足其特定的包装要求。公司获得了ISO9001-2000管理体系认证，产品通过UL62275, CE， SGS，RoHs, TUV/SUD, Reach, VDE等机构的测试。上海新龙塑料制造有限公司的使命是成为卓越的全球领导者，以造福我们的客户，员工和环境。",
  download: "下载",
  filter: "筛选",
  proname: "品名",
  pull: "拉力",
  length: "长度",
  width: "宽度",
  classifylist: "分类列表",
  productVideo: "视频",
  recommend: "相关推荐",
  prodeuctdetail: "产品详情",
  productname: "产品名称",
  productlength: "产品长度",
  productwidth: "产品宽度",
  productpull: "产品拉力",
  briefintroduction: "产品简介",
  newsdetail: "新闻详情",
  guanzhu: "更多精彩，请关注我们",
  enterText: "请输入搜索产品",
  picture: "产品图",
  image: "图纸",
};
